import { ILandingResponse } from '../types/landing-api-response.model';
import { ILandingCard } from '../types/landing-card.model';

function createLink(embedUrl: string, prefix: string) {
  if (embedUrl && embedUrl.startsWith('https')) {
    const encodedUrl = window.btoa(embedUrl);
    return {
      link: `/home/pbi-screen?pbiUrl=${encodedUrl}`,
      pbiUrl: `?pbiUrl=${encodedUrl}`
    };
  }
  return {
    link: embedUrl || `/home/${prefix.toLowerCase().replaceAll(' ', '-')}`,
    pbiUrl: ''
  };
}

export default function apiResponseToCards(
  response: ILandingResponse
): ILandingCard[] {
  return Object.keys(response).map((cardTitle) => ({
    title: cardTitle,
    tabs: Object.values(response[cardTitle]).every((obj) => obj.is_leaf)
      ? [
          {
            tabTitle: '',
            links: Object.keys(response[cardTitle]).map((description) => ({
              ...createLink(
                (response[cardTitle] as ILandingResponse)[description]
                  .embed_url as string,
                description
              ),
              description
            }))
          }
        ]
      : Object.keys(response[cardTitle]).map((tabTitle) => ({
          tabTitle,
          links: Object.keys(
            (response[cardTitle] as ILandingResponse)[tabTitle]
          ).map((leafNode) => ({
            ...createLink(
              (
                (response[cardTitle] as ILandingResponse)[
                  tabTitle
                ] as ILandingResponse
              )[leafNode].embed_url as string,
              leafNode
            ),
            description: leafNode
          }))
        }))
  }));
}
